
import {requestGet, requestPost} from '../utils/request';
export function login(params) {
    return requestPost(process.env.PREACT_APP_BASE_URL,'/account/login',params)
}

export function get_insure_type(params) {
    return requestGet(process.env.PREACT_APP_BASE_URL,'/pattern/insure/type',params)
}

export function get_account(params) {
    return requestGet(process.env.PREACT_APP_BASE_URL,'/account/profile',params)
}

export function create_log(params) {
    let _params = params;
    _params.from = 'web';
    return requestPost(process.env.PREACT_APP_API_URL,'/sys_operate_log/external_write_sys_log',_params)
}
